module.exports = __webpack_public_path__ + "img/no-patient.598f42cf.svg";